import React, { useState, useEffect } from "react";
import styles from "../../styles/Banner.module.scss";
import { isBrowser } from "react-device-detect";
import { ParallaxImage } from "./ParallaxImage";

const preloadAsset = (url) => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = url;
  document.head.appendChild(link);
};

const Banner = (props) => {
  const {
    desktopImage,
    mobileImage,
    alt,
    redirectURL,
    mobileRedirectURL,
    external,
    bannerStyle,
    mobileBreakpoint,
    noRedirect,
    parallax,
  } = props;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  // const imageUrl = windowWidth >= 650 ? desktopImage : mobileImage;
  const breakpoint = mobileBreakpoint ? mobileBreakpoint : 900;
  const isDesktop = windowWidth >= breakpoint
  const responsiveImage = isDesktop? desktopImage : mobileImage;
  // use the mobile click url if screensize is mobile and mobile click url is defined - otherwise just use desktop (OK if both are undefined)
  const deviceSpecificRedirectURL = isDesktop || mobileRedirectURL === undefined? redirectURL : mobileRedirectURL

  useEffect(() => {
    preloadAsset(responsiveImage);
  }, [responsiveImage]);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const handleBannerRedirect = (e) => {
    e.preventDefault();
    if (!noRedirect && deviceSpecificRedirectURL !== undefined) {
      window.dataLayer.push({
        'event': 'bannerClick',
        'destinationUrl': deviceSpecificRedirectURL
      });      
      if (external) {
        window.open(deviceSpecificRedirectURL, "_blank");
      } 
      else {
        props.router.history.push(deviceSpecificRedirectURL);
      }
    }
  };

  return (
    <div
      style={bannerStyle}
      className={noRedirect ? styles.bannerNoRedirect : styles.banner}
      onClick={handleBannerRedirect}
    >
      {parallax && isBrowser ? (
        <ParallaxImage {...props} responsiveImage={responsiveImage} />
      ) : (
        <img src={responsiveImage} alt={alt || responsiveImage}></img>
      )}
      {props.children}
    </div>
  );
};

export default Banner;
